export const StyleConstants = {
  // Header and section spacing
  contentTopPadding: '16px',  // Space from red line to content
  contentSidePadding: '24px',
  contentBottomPadding: '24px', // Space at the bottom of scrollable content areas
  
  // Section Title styling
  sectionTitle: {
    fontSize: '24px',
    fontWeight: '700',
    color: 'var(--primary-dark-blue)',
    margin: 0,  // No margin on section titles - container handles spacing
    padding: 0,
    lineHeight: '32px',
  },
  
  // Status counter styling
  statusCounter: {
    fontSize: '16px',
    color: '#666',
    fontWeight: 'normal',
    marginLeft: '8px',
  },
  
  // Card spacing
  cardGap: '24px',
  
  // Card styling
  propertyCard: {
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    overflow: 'hidden',
    backgroundColor: '#fff',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  
  // Grid containers
  splitViewGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '24px',
  },
  
  galleryViewGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
    gap: '24px',
    width: '100%',
    justifyItems: 'center',
    padding: '0 16px',
    boxSizing: 'border-box'
  }
};
